/* eslint-disable react/require-default-props */
import { HivePaymentData, SortDirType, SortType } from '@/api/financial/types';
import { Box, Pagination } from '@mui/material';

import { StyledLinearProgress } from '../../../../components/UI/Typography';
import { Constants } from '../../../../constants/finance';
import Table from '../Table';
import {
  PagesContainer,
  LoadingBox,
  SelectedMonthIndicator,
  PendingOnlyIndicator,
} from './styles';

interface ActivesProps {
  loading: boolean;
  paymentsData: HivePaymentData[];
  getDataCallback: () => Promise<void>;
  page: number;
  totalPages: number;
  sort: { by: SortType; dir: SortDirType } | null;
  handleNextPage: (event: React.ChangeEvent<unknown>, value: number) => void;
  handleSort: (value: SortType) => void;
  formattedDate?: string;
  pendingOnly?: boolean;
}

export function TabContent({
  loading,
  paymentsData,
  getDataCallback,
  page,
  totalPages,
  sort,
  handleNextPage,
  handleSort,
  formattedDate,
  pendingOnly = false,
}: ActivesProps): JSX.Element {
  return loading ? (
    <LoadingBox>
      <StyledLinearProgress />
    </LoadingBox>
  ) : (
    <Box width="100%">
      {paymentsData.length > 0 ? (
        <>
          {pendingOnly ? (
            <PendingOnlyIndicator>{Constants.pendingOnly}</PendingOnlyIndicator>
          ) : (
            formattedDate && (
              <SelectedMonthIndicator>{formattedDate}</SelectedMonthIndicator>
            )
          )}
          <Table
            tableData={paymentsData}
            updateData={getDataCallback}
            handleSort={handleSort}
            sort={sort}
          />
          <PagesContainer>
            <Pagination
              page={page}
              count={totalPages}
              onChange={handleNextPage}
            />
          </PagesContainer>
        </>
      ) : (
        <Box>{Constants.noPayments}</Box>
      )}
    </Box>
  );
}
